export default __webpack_public_path__ + "static/media/kingIcon.4ebc9b4c.png";